import { apiGet, apiPost } from './apiClient';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const listConversations = (token, params = {}) =>
  apiGet(`/api/admin/messages/conversations${buildQuery(params)}`, token);

export const getConversation = (conversationId, token, params = {}) =>
  apiGet(`/api/admin/messages/conversations/${conversationId}/messages${buildQuery(params)}`, token);

export const sendMessage = (conversationId, text, token) =>
  apiPost(`/api/admin/messages/conversations/${conversationId}/messages`, { text }, token);

export const addNote = (conversationId, note, token) =>
  apiPost(`/api/admin/messages/conversations/${conversationId}/note`, { note }, token);

export const deleteMessage = (messageId, token) =>
  apiPost(`/api/admin/messages/messages/${messageId}/delete`, {}, token);

export const unflag = (conversationId, token) =>
  apiPost(`/api/admin/messages/conversations/${conversationId}/unflag`, {}, token);

export const mute = (conversationId, target, muted, token) =>
  apiPost(`/api/admin/messages/conversations/${conversationId}/mute`, { target, muted }, token);

export const exportConversation = async (conversationId, token) => {
  const res = await fetch(
    `${process.env.REACT_APP_API_BASE_URL || ''}/api/admin/messages/conversations/${conversationId}/export`,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      credentials: 'include',
    }
  );
  if (!res.ok) {
    const message = (await res.json().catch(() => ({})))?.message || 'Export failed';
    throw new Error(message);
  }
  return res.json();
};


